<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><a id="page_7"></a>This story is affectionately dedicated to all good friends of my Peking days, specifically to Yi Ying, Helen Burton, Ida Pruitt, Kay Todd, Lucille Swan, Dorothy St. Clair, Eleanor and Owen Lattimore, Peg and Edgar Snow, Dorothea and Frank Smothers, Zina and Frank Oliver, Mayo Newhall, John Hope-Johnstone, Malcolm MacDonald, Lin Yutang, and Chen Shu-yi.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?df92b78e